import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getDoneWorks(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS,
		ModulesConfigMap[ModulesMap.DONE_WORKS].GET_DONE_WORKS,
		options
	)
}
function _getDoneWorkPreview(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS,
		ModulesConfigMap[ModulesMap.DONE_WORKS].GET_DONE_WORK_PREVIEW,
		options
	)
}
function _getDoneWorkPopup(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS,
		ModulesConfigMap[ModulesMap.DONE_WORKS].GET_DONE_WORK_POPUP,
		options
	)
}

function _createDoneWork(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS,
		ModulesConfigMap[ModulesMap.DONE_WORKS].CREATE_DONE_WORK,
		options
	)
}

function _getDoneWork(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS,
		ModulesConfigMap[ModulesMap.DONE_WORKS].GET_DONE_WORK,
		options
	)
}

function _patchDoneWork(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS,
		ModulesConfigMap[ModulesMap.DONE_WORKS].PATCH_DONE_WORK,
		options
	)
}

function _putDoneWork(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS,
		ModulesConfigMap[ModulesMap.DONE_WORKS].PUT_DONE_WORK,
		options
	)
}

function _deleteDoneWork(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS,
		ModulesConfigMap[ModulesMap.DONE_WORKS].DELETE_DONE_WORK,
		options
	)
}

export default {
	[ModulesConfigMap[ModulesMap.DONE_WORKS].GET_DONE_WORKS]: _getDoneWorks,

	[ModulesConfigMap[ModulesMap.DONE_WORKS].GET_DONE_WORK_PREVIEW]: _getDoneWorkPreview,
	[ModulesConfigMap[ModulesMap.DONE_WORKS].GET_DONE_WORK_POPUP]: _getDoneWorkPopup,

	[ModulesConfigMap[ModulesMap.DONE_WORKS].CREATE_DONE_WORK]: _createDoneWork,
	[ModulesConfigMap[ModulesMap.DONE_WORKS].GET_DONE_WORK]: _getDoneWork,
	[ModulesConfigMap[ModulesMap.DONE_WORKS].PATCH_DONE_WORK]: _patchDoneWork,
	[ModulesConfigMap[ModulesMap.DONE_WORKS].PUT_DONE_WORK]: _putDoneWork,
	[ModulesConfigMap[ModulesMap.DONE_WORKS].DELETE_DONE_WORK]: _deleteDoneWork,
}